import InstanceProvisioning from "./InstanceProvisioning";

export default InstanceProvisioning;
